(function () {
  var dataEl = document.getElementById('pdp-enhancements-data');
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  // Zoom script — load on first user interaction
  if (data.zoomUrl) {
    var zoomLoaded = false;
    var zoomEvents = ['mousemove', 'touchstart', 'keydown', 'scroll'];

    function loadZoom() {
      if (zoomLoaded) return;
      zoomLoaded = true;
      zoomEvents.forEach(function (evt) {
        window.removeEventListener(evt, loadZoom);
      });
      var script = document.createElement('script');
      script.src = data.zoomUrl;
      document.head.appendChild(script);
    }

    zoomEvents.forEach(function (evt) {
      window.addEventListener(evt, loadZoom, { passive: true });
    });
  }

  // Klaviyo — track "Added to Cart" on submit click
  if (data.klaviyoItem) {
    var submitBtn = document.querySelector('.product-form__submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Added to Cart', data.klaviyoItem]);
      });
    }
  }

  // Sticky "See Buying Options" bar — mobile only
  if (window.innerWidth < 750) {
    var bar = document.getElementById('pdp-sticky-bar');
    var btn = document.getElementById('pdp-sticky-bar-btn');
    var targets = document.querySelectorAll('.product-form__submit');

    if (bar && btn && targets.length) {
      var target = targets[0];

      btn.addEventListener('click', function () {
        /* If the product has multiple variants, scroll to the variant
           picker instead of the buy button. Centering on the CTA clips
           the size/flavor options above it out of view, so customers
           don't realize they have a choice. */
        var variantPicker = document.querySelector('variant-selects, variant-radios');
        var buySection =
          variantPicker ||
          document.querySelector('.bulk-purchase-v2') ||
          document.querySelector('.bundle-purchase-form') ||
          target.closest('form') ||
          target;
        buySection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );

      observer.observe(target);
    }
  }
})();
